let authToken: string | null = null;

/**
 * Sets the authentication token.
 * @param token - The authentication token to set.
 */
export const setAuthToken = (token: string) => {
    authToken = token;
};

/**
 * Retrieves the current authentication token.
 * @returns The current authentication token or null if not set.
 */
export const getAuthToken = (): string | null => {
    return authToken;
};
